<template>
  <div class="layout bd-b-gray30 ai-center ITEM text-sm:mo p-x-2 p-x-1:mo">
    <div
        v-tooltip="{
          content: service.name
        }"
        id="name"
        class="layout-item is-4">{{ service.name }}</div>
    <div id="payment" class="layout-item is-5 p-r-2">
      <vk-listbox
          v-model="selectedUnit"
          @input="update"
          :options="units"
          :display-text="displayText"
          option-label="label"
          option-value="value"
          class="INPUT PRICE">
        <vk-listbox-option
            v-for="unit in units"
            :key="unit.label"
            :value="unit.value"
            class="bd-b-gray50"
            :class="{ 'bg-gray30': unit.value === selectedUnit }"
            :selected="unit.value === selectedUnit"
        >
          {{ unit.label }}
        </vk-listbox-option>
      </vk-listbox>
    </div>
    <div id="pricing" class="layout-item is-3 ">
      <div class="">

        <div class="" v-if="isContactForPricing">
          <input
              type="text"
              :disabled="isContactForPricing"
              class="DISABLED p-l-1 PRICING"
              :placeholder="$options.PRICING_OPTIONS.contact.label"
          />
        </div>
        <div v-else-if="range" class=" ">
          <div class="d-flex">
            <input
                type="text"
                id="minimum_price"
                class="PRICING INPUT-WIDTH-RANGE p-l-1"
                v-model="minimumPrice"
                @input="validateMin"
                placeholder="$"
                autocomplete="off"
            />
            <input
                type="text"
                class="m-l-2 m-l-1:mo PRICING INPUT-WIDTH-RANGE p-l-1"
                v-model="maximumPrice"
                @input="validateMax"
                placeholder="$"
                autocomplete="off"
            />
          </div>
        </div>
        <div v-else class="">
          <input
              type="text"
              class="w-100 p-l-1 PRICING"
              v-model="singlePrice"
              @input="validateSingle"
              placeholder="$"
              autocomplete="off"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectBox from '@/components/SelectBox';
import { PRICING_OPTIONS } from '../../constants/pricing-options';

export default {
  PRICING_OPTIONS,
  name: 'pricing-service-item',
  components: {
    SelectBox,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      minimumPrice: `$${this.service.minimum_price}` || '',
      maximumPrice: `$${this.service.maximum_price}` || '',
      singlePrice: `$${this.service.maximum_price}` || '',
      selectedUnit: this.service.unit,
      units: Object.values(PRICING_OPTIONS),
    };
  },
  computed: {
    isContactForPricing () {
      return this.selectedUnit === null;
    },
    displayText () {
      return this.units.find(unit => unit.value === this.selectedUnit).label;
    },
    range () {
      return this.selectedUnit === this.$options.PRICING_OPTIONS.range.value;
    },
  },
  watch: {
    maximumPrice (prev, cur) {
      if (prev !== cur) {
        this.validateMax();
      }
    },
    minimumPrice (prev, cur) {
      if (prev !== cur) {
        this.validateMin();
      }
    },
    singlePrice (prev, cur) {
      if (prev !== cur) {
        this.validateSingle();
      }
    },
  },
  async mounted () {
    if (this.service.unit === this.$options.PRICING_OPTIONS.range.value) {
      this.validateMax();
      this.validateMin();
    } else {
      this.validateSingle();
    }
  },
  methods: {
    validateMax () {
      if (this.maximumPrice) {
        const value = this.maximumPrice.replace(/\D/g, '');
        this.maximumPrice = value ? `$${value}` : '';
        this.update();
      }
    },
    validateMin () {
      if (this.minimumPrice) {
        const value = this.minimumPrice.replace(/\D/g, '');
        this.minimumPrice = value ? `$${value}` : '';
        this.update();
      }
    },
    validateSingle () {
      if (this.singlePrice) {
        const value = this.singlePrice.replace(/\D/g, '');
        this.singlePrice = value ? `$${value}` : '';
        this.maximumPrice = value ? `$${value}` : '';
        this.minimumPrice = value ? `$${value}` : '';
        this.update();
      }
    },
    update () {
      const max = this.selectedUnit ? parseInt(this.maximumPrice.replace('$', ''), 10) : null;
      const min = this.selectedUnit ? parseInt(this.minimumPrice.replace('$', ''), 10) : null;
      const unit = max && min ? this.selectedUnit : null;
      const updatedService = {
        id: this.service.id,
        maximum_price: max,
        minimum_price: min,
        unit,
      };
      this.$emit('input', updatedService);
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  ::v-deep .BAR {
    display: none;
  }
  ::v-deep VK-LISTBOX-MENU {
    height: 100%;
  }
  ::v-deep .CHEVRON {
    color: black;
  }
  .INPUT-WIDTH {
    width: 50%;
  }
  .INPUT-WIDTH-RANGE {
    width:50%;
  }

  .PRICING {
    height: 48px;
  }

  .ITEM {
    min-height: 72px;
  }
  .INPUT {

    text-overflow: ellipsis;
  }
  input{
    border: solid 1px $color-gray60;
    border-radius: 3px;
    min-height: 44px;
  }
  .DISABLED {
    height: 48px;
    width: 100%;
    border: 1px solid $color-gray50;
    pointer-events: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &::placeholder{
      color: $color-gray50;
    } ;
  }
  </style>
